<template>
  <div class="ms-entry-loading" role="status" aria-live="polite" aria-busy="true" :aria-label="label">
    <span class="ms-entry-status">{{ label }}</span>
    <BrandIntro v-if="!failed" class="ms-entry-animation" :duration="ENTRY_ANIMATION_MS" @ready="ready" @complete="$emit('complete')" @error="imageFailed" />
    <div class="ms-entry-fallback" :class="{visible:failed}" aria-hidden="true">
      <img src="../assets/brand-mark.png" width="96" height="96" alt="">
      <img src="../assets/brand-wordmark.png" width="393" height="82.055" alt="">
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import BrandIntro from './BrandIntro.vue';
import {beginEntryTimeline,ENTRY_ANIMATION_MS} from '../entryTimeline.mjs';
defineProps({label:{type:String,default:'正在加载经营工作台'}});
const emit=defineEmits(['ready','complete']);
const failed=ref(false);
function ready(){beginEntryTimeline();emit('ready');}
function imageFailed(){failed.value=true;ready();emit('complete');}
</script>

<style scoped>
.ms-entry-loading{position:fixed;inset:0;z-index:20000;display:grid;grid-template-columns:minmax(0,1fr);place-items:center;overflow:hidden;background:#f7f9fb url('../assets/brand-intro-background.svg') center / cover no-repeat;isolation:isolate}
.ms-entry-status{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;border:0}
/* Fill the window with the background while the transparent logo artwork
   fits proportionally inside it, including narrow and ultrawide screens. */
.ms-entry-animation{display:block;width:100vw;height:100dvh;object-fit:contain}
.ms-entry-fallback{display:none;align-items:center;gap:30px;width:519px;height:96px}
.ms-entry-fallback.visible{display:flex}
.ms-entry-fallback img{display:block;flex:none;max-width:none;object-fit:contain}
@media(max-width:600px){.ms-entry-fallback{transform:scale(.62)}}
@media(max-width:360px){.ms-entry-fallback{transform:scale(.52)}}
@media(prefers-reduced-motion:reduce){.ms-entry-animation{display:none}.ms-entry-fallback{display:flex}}
</style>
